/**
 * Workspace Favorites Route - View favorite items
 *
 * Shows all favorited tables and linked tables.
 * Part of the Data Workspace OS feature set.
 */

import { createFileRoute } from '@tanstack/react-router';

import { WorkspacePage } from '@/features/workspace';
import { workspaceSearchSchema } from '@/features/workspace/utils/workspaceSearchSchema';

export const Route = createFileRoute('/_authenticated/_withWorkspace/workspace/favorites')({
  component: WorkspaceFavoritesPage,
  validateSearch: workspaceSearchSchema,
});

function WorkspaceFavoritesPage() {
  const search = Route.useSearch();

  // Data fetching is handled by useWorkspaceItems via TanStack Query
  // No manual fetch calls needed - queries auto-fetch on mount

  return (
    <WorkspacePage
      showFavorites
      searchParams={search}
    />
  );
}
